"use client";

import { format } from "date-fns";
import { SunIcon, SunriseIcon, SunsetIcon } from "lucide-react";
import { Heading } from "../ui/heading";
import { Button } from "../ui/button";
import { Card, CardContent } from "../ui/card";
interface TimeSection {
  title: string;
  icon: React.ReactNode;
  slots: string[];
}
interface TimeSlotPickerProps {
  selectedDate?: Date;
  selectedTime: string;
  onTimeSelect: (time: string) => void;
  hideHeading?: boolean;
  className?: string;
}
export const TimeSlotPicker = (props: TimeSlotPickerProps) => {
  const {
    selectedDate = new Date(),
    selectedTime,
    onTimeSelect,
    hideHeading = false,
    className
  } = props;
  const timeSections: TimeSection[] = [{
    title: "Morning",
    icon: <SunriseIcon className="text-primary-main size-4 [&>path]:stroke-[2px]" />,
    slots: ["09:00 AM", "10:00 AM", "11:00 AM"]
  }, {
    title: "Afternoon",
    icon: <SunIcon className="text-primary-main size-4 [&>path]:stroke-[2px]" />,
    slots: ["12:00 PM", "01:00 PM", "02:00 PM"]
  }, {
    title: "Evening",
    icon: <SunsetIcon className="text-primary-main size-4 [&>path]:stroke-[2px]" />,
    slots: ["03:00 PM", "04:00 PM", "05:00 PM"]
  }];
  return <Card className={className}>
      {!hideHeading && <Heading as="h3" className="mb-6">
          {format(selectedDate, "EEEE, MMMM d")}
        </Heading>}

      <CardContent className="space-y-8">
        {timeSections.map(section => <div key={section.title}>
            <div className="mb-4 flex items-center gap-2">
              {section.icon}
              <Heading as="h4" className="font-regular">
                {section.title}
              </Heading>
            </div>
            <div className="grid grid-cols-2 gap-3 md:grid-cols-3">
              {section.slots.map(time => <Button key={time} onClick={() => onTimeSelect(time)} size="sm" variant={selectedTime === time ? "default" : "outline"}>
                  {time}
                </Button>)}
            </div>
          </div>)}
      </CardContent>
    </Card>;
};